import ReportPreviewData from "./interfaces/ReportPreviewData";
import {
  getFieldGroups,
  getSelfServiceReport,
  getSelfServiceReportDataPreview,
} from "../service";
import FieldGroup from "../interfaces/FieldGroup";
import { getUniqueFieldsFromGroups } from "./utils";

export const getReportPreviewData = async (
  reportId?: string
): Promise<ReportPreviewData> => {
  let report;
  let reportData;

  const fieldGroupsPromise = getFieldGroups();

  if (reportId) {
    report = await getSelfServiceReport(reportId);
    reportData = await getSelfServiceReportDataPreview(report.fieldConfigs);
  }

  const allFieldGroups = await fieldGroupsPromise;

  const defaultFieldGroups: FieldGroup[] = [];
  const nonDefaultFieldGroups: FieldGroup[] = [];

  allFieldGroups.forEach((group) => {
    if (group.isDefault) {
      defaultFieldGroups.push(group);
    } else {
      nonDefaultFieldGroups.push(group);
    }
  });

  const allFields = getUniqueFieldsFromGroups(allFieldGroups);
  const defaultFields = getUniqueFieldsFromGroups(defaultFieldGroups);
  const nonDefaultFields = getUniqueFieldsFromGroups(nonDefaultFieldGroups);

  return {
    allFieldGroups,
    defaultFieldGroups,
    nonDefaultFieldGroups,
    allFields,
    defaultFields,
    nonDefaultFields,
    report,
    reportData,
  };
};
